export const phonePrefixes = [
    { label: '+49', code: '+49', icon: 'de' },  // Alemania
    { label: '+43', code: '+43', icon: 'at' },  // Austria
    { label: '+32', code: '+32', icon: 'be' },  // Bélgica
    { label: '+359', code: '+359', icon: 'bg' }, // Bulgaria
    { label: '+420', code: '+420', icon: 'cz' }, // República Checa
    { label: '+357', code: '+357', icon: 'cy' }, // República de Chipre
    { label: '+385', code: '+385', icon: 'hr' }, // Croacia
    { label: '+45', code: '+45', icon: 'dk' },  // Dinamarca
    { label: '+421', code: '+421', icon: 'sk' }, // Eslovaquia
    { label: '+386', code: '+386', icon: 'si' }, // Eslovenia
    { label: '+34', code: '+34', icon: 'es' },  // España
    { label: '+372', code: '+372', icon: 'ee' }, // Estonia
    { label: '+358', code: '+358', icon: 'fi' }, // Finlandia
    { label: '+33', code: '+33', icon: 'fr' },  // Francia
    { label: '+30', code: '+30', icon: 'gr' },  // Grecia
    { label: '+36', code: '+36', icon: 'hu' },  // Hungría
    { label: '+353', code: '+353', icon: 'ie' }, // Irlanda
    { label: '+354', code: '+354', icon: 'is' }, // Islandia
    { label: '+39', code: '+39', icon: 'it' },  // Italia
    { label: '+371', code: '+371', icon: 'lv' }, // Letonia
    { label: '+370', code: '+370', icon: 'lt' }, // Lituania
    { label: '+352', code: '+352', icon: 'lu' }, // Luxemburgo
    { label: '+356', code: '+356', icon: 'mt' }, // Malta
    { label: '+31', code: '+31', icon: 'nl' },  // Países Bajos
    { label: '+48', code: '+48', icon: 'pl' },  // Polonia
    { label: '+351', code: '+351', icon: 'pt' }, // Portugal
    { label: '+40', code: '+40', icon: 'ro' },  // Rumania
    { label: '+46', code: '+46', icon: 'se' }   // Suecia
  ];
